// sections: main-product / featured-product
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    if(this.querySelector('[id^="Deferred-Poster-"]')){
      if(this.querySelector('span.deferred-media__poster-button')){
        this.querySelector('[id^="Deferred-Poster-"]').addEventListener('click', this.loadContent.bind(this));
      } else {
        this.loadContent();
      }
    }
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      this.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
      if(this.querySelector('span.deferred-media__poster-button')) {
        this.querySelector('span.deferred-media__poster-button').style.display = 'none';
        if(this.closest('.swiper.swiper-initialized').length > 0){
          this.closest('.swiper.swiper-initialized').swiper.allowTouchMove = false;
        }
      }
      theme.utils.pauseAllMedia();
    }
  }
}

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    if(this.querySelector('[id^="ModalClose-"]')){
      this.querySelector('[id^="ModalClose-"]').addEventListener('click', 
        this.hide.bind(this)
      );
    }

    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.querySelector('html').classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if(this.querySelector('.template-popup')){
      this.querySelector('.template-popup').loadContent();
    }
  }

  hide() {
    document.querySelector('html').classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.dispatchEvent(new CustomEvent("modalClose"));
  }
}

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp);
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.focus();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open')
  }
}
customElements.define('details-disclosure', DetailsDisclosure);

class ShareButton extends DetailsDisclosure {
  constructor() {
    super();

    this.elements = {
      shareButton: this.querySelector('button'),
      successMessage: this.querySelector('[id^="ShareMessage"]'),
      urlInput: this.querySelector('input')
    }

    if(!navigator.canShare){
      this.mainDetailsToggle.setAttribute('hidden', '');
      this.elements.shareButton.classList.remove('hidden');
      this.elements.shareButton.addEventListener('click', () => { navigator.share({ url: document.location.href, title: document.title }) });
    } else {
      this.mainDetailsToggle.removeAttribute('hidden');
      this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
      this.mainDetailsToggle.querySelector('button').addEventListener('click', this.copyToClipboard.bind(this));
    }
  }

  toggleDetails() {
    if (!this.mainDetailsToggle.open)
      this.elements.successMessage.classList.add('hidden');
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
      this.elements.successMessage.classList.remove('hidden');
      this.elements.successMessage.setAttribute('aria-hidden', false);

      setTimeout(() => {
        this.elements.successMessage.setAttribute('aria-hidden', true);
      }, 6000);
    });
  }
}
customElements.define('share-button', ShareButton);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('quantity-input', QuantityInput);

class ButtonAnimation extends HTMLElement {
  constructor() {
    super();

    var self = this;
    let button = this.querySelector('button.btn--atc');

    var update = function () {
      button.style.animationName = 'none';
      setTimeout(function(){
        button.style.animationName = '';
      }, 2000);
      setTimer();
    };

    var setTimer = function () {
      setTimeout(function () {
        requestAnimationFrame(update);
      }, parseInt(self.getAttribute('data-animation-duration')) * 1e3);
    };

    setTimer();
  }
}
customElements.define('button-animation', ButtonAnimation);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();

    if(!this.hasAttribute('available')) return;

    this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
    this.onClickRefreshList = this.onClickRefreshList.bind(this);
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${this.dataset.baseUrl}variants/${variantId}/?section_id=pickup-availability`;

    fetch(variantSectionUrl)
      .then(response => response.text())
      .then(text => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('.shopify-section');
        this.renderPreview(sectionInnerHTML);
      })
      .catch(e => {
        if(this.querySelector('.btn--link')){
          this.querySelector('.btn--link').removeEventListener('click', this.onClickRefreshList);
        }
        this.renderError();
      });
  }

  onClickRefreshList(evt) {
    this.fetchAvailability(this.dataset.variantId);
  }

  renderError() {
    this.innerHTML = '';
    this.appendChild(this.errorHtml);

    this.querySelector('.btn--link').addEventListener('click', this.onClickRefreshList);
  }

  renderPreview(sectionInnerHTML) {
    const drawer = document.querySelector('pickup-availability-drawer');
    if (drawer) drawer.remove();
    if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
      this.innerHTML = "";
      this.removeAttribute('available');
      return;
    }

    this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
    this.setAttribute('available', '');

    document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));

    this.querySelector('.btn--link').addEventListener('click', (evt) => {
      document.querySelector('pickup-availability-drawer').show(evt.target);
    });
  }
}
customElements.define('pickup-availability', PickupAvailability);

class PickupAvailabilityDrawer extends HTMLElement {
  constructor() {
    super();

    this.onBodyClick = this.handleBodyClick.bind(this);

    this.querySelector('button').addEventListener('click', () => {
      this.hide();
    });

    this.addEventListener('keyup', () => {
      if(event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target != this && !target.closest('pickup-availability-drawer') && target.id != 'ShowPickupAvailabilityDrawer') {
      this.hide();
    }
  }

  show(focusElement) {
    this.focusElement = focusElement;
    this.setAttribute('open', '');
    document.body.addEventListener('click', this.onBodyClick);
    document.body.style.top = `-${window.pageYOffset}px`,
    document.body.classList.add('overflow-hidden-fixed')
    trapFocus(this);
  }

  hide() {
    this.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClick);
    this.scrollY = document.body.style.top,
    document.body.style.top = '',
    document.body.classList.remove('overflow-hidden-fixed'),
    window.scrollTo({left: 0, top: parseInt(this.scrollY || '0') * -1, behavior: "instant"});
    removeTrapFocus(this.focusElement);
  }
}
customElements.define('pickup-availability-drawer', PickupAvailabilityDrawer);

class VariantSelects extends HTMLElement {
  constructor() {
    super();

    this.linkOptionsSelectors();
    this.selectVariant();
    this.addEventListener('change', this.onVariantChange);
    this.addEventListener('sliderChange', this.onSliderChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantSelected();
      this.renderProductInfo();
    }
  }

  onSliderChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantSelected();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('[data-options-index]'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  linkOptionsSelectors(){
    let optionsMap = {};
    var self = this;
    var variants = this.getVariantData();
    let option2 = false, option3 = false;

    if(variants){
      for (var i=0 ; i< variants.length; i++) {
        let variant = variants[i];
        if (variant.available) {
          optionsMap['root'] = optionsMap['root'] || [];
          optionsMap['root'].push(variant.option1);
          optionsMap['root'] = theme.utils.uniq(optionsMap['root']);

          if (variant.option2 != null || variant.option3 != null) {
            var key = variant.option1;
            option2  = (this.querySelectorAll('[data-options-index="1"]').length > 0 || this.querySelectorAll('[data-options-index="2"]').length > 0) ? true : false;
            optionsMap[key] = optionsMap[key] || [];
            optionsMap[key].push(variant.option2);
            optionsMap[key] = theme.utils.uniq(optionsMap[key]);
          }

          if(variant.option2 != null && variant.option3 != null) {
            var key = variant.option1 + ' / ' + variant.option2;
            option3  = (this.querySelectorAll('[data-options-index="1"]').length > 0 && this.querySelectorAll('[data-options-index="2"]').length > 0) ? true : false;
            optionsMap[key] = optionsMap[key] || [];
            optionsMap[key].push(variant.option3);
            optionsMap[key] = theme.utils.uniq(optionsMap[key]);
          }
        }
      }

      this.updateOptionsInSelector(0, optionsMap);
      if (option2 || option3) this.updateOptionsInSelector(1, optionsMap);
      if (option2 && option3) this.updateOptionsInSelector(2, optionsMap);

      // When there is an update in the first dropdown.
      if (option2 || option3){
        this.querySelectorAll('[data-options-index="0"]').forEach((option) => option.addEventListener('change', function() {
          self.updateOptionsInSelector(1, optionsMap);
          if (option2 && option3) self.updateOptionsInSelector(2, optionsMap);
          return true;
        }));
      }

      // When there is an update in the second dropdown.
      if (option2 && option3){
        this.querySelectorAll('[data-options-index="1"]').forEach((option) => option.addEventListener('change', function() {
          self.updateOptionsInSelector(2, optionsMap);
          return true;
        }));
      }
    }
  }

  updateOptionsInSelector(selectorIndex, optionsMap){
    let dropdown = this.querySelectorAll('select[data-options-index]').length > 0 ? true : false;
    switch (selectorIndex) {
      case 0:
        var key = 'root';
        break;
      case 1:
        var key = dropdown ? this.querySelector('select[data-options-index="0"]').value : this.querySelector('input[data-options-index="0"]:checked').value;
        break;
      case 2:
        if(dropdown){
        var key = this.querySelector('select[data-options-index="0"]').value;
        key += ' / ' + this.querySelector('select[data-options-index="1"]').value;
      } else { 
        var key = this.querySelector('input[data-options-index="0"]:checked').value;
        key += ' / ' + this.querySelector('input[data-options-index="1"]:checked').value;
      }
    }

    var availableOptions = optionsMap[key];
    let typeOptions = dropdown ? 'select[data-options-index="' + selectorIndex + '"] option' : 'input[data-options-index="' + selectorIndex + '"]';
    if(typeof availableOptions !== "undefined"){
      this.querySelectorAll(typeOptions).forEach((option) => {
          availableOptions.includes(option.value) ?
            option.removeAttribute('disabled','disabled') :
            option.setAttribute('disabled','disabled');
      });
    }
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media ? !this.currentVariant.featured_media : false) return;
    const newMedia = document.querySelector(
      `.product__media--main [data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;

    const productImages = document.querySelector(`#ProductsImages-${this.dataset.section} .product__media--main:not(.triple-slider-prev):not(.triple-slider-next)`);

    if(document.documentElement.clientWidth >= 780){
      if(productImages.getAttribute('data-active') == "true"){
        let index = parseInt(newMedia.getAttribute('data-index'));
        productImages.swiper.slideToLoop(index)
      } else {
        window.setTimeout(() => {
          var rect = newMedia.getBoundingClientRect();
          var offsetTop = rect.top + window.scrollY;
          theme.utils.scrollToSmoothly(offsetTop, 400);
        }, 300);
      }
    } else if(productImages.getAttribute('datamob-active') == "true"){
      let index = parseInt(newMedia.getAttribute('data-index'));
      productImages.swiper.slideToLoop(index)
    }
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantSelected() {
    var self = this;
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = self.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant ? this.currentVariant.available : false) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        let id = `price-${this.dataset.section}`;
        let destination = document.getElementById(id);
        let source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML; 

        document.querySelector(`#price-${this.dataset.section}`) ?
        (
          document.querySelector(`#price-${this.dataset.section} .price`).classList.remove('price-visibility-hidden'),
          document.querySelector(`#price-${this.dataset.section} .product__select_variant`).classList.add('hide')
        ) : "";

        document.querySelectorAll('.shopify-payment-button').length > 0 ? document.querySelectorAll('.shopify-payment-button').forEach((button) => { button.classList.remove('visibility-hidden')}) : "";

        this.toggleAddButton(!this.currentVariant.available, theme.strings.soldOut);
        this.dispatchEvent(new CustomEvent('variantRendered'));

        id = `promotion-${this.dataset.section}`;
        destination = document.getElementById(id);
        source = html.getElementById(id);
        if (source && destination && !source.classList.contains('hide')) { destination.innerHTML = source.innerHTML; destination.classList.remove('hide'); }
        else if(source && destination && source.classList.contains('hide')) { destination.classList.add('hide') };
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`) ? document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]') : "";

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.querySelector('span:first-child').textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.querySelector('span:first-child').textContent = theme.strings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)? document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]') : "";
    if (!addButton) return;
    addButton.textContent = theme.strings.unavailable;
    document.querySelector(`#price-${this.dataset.section}`) ?
    (
      document.querySelector(`#price-${this.dataset.section} .price`).classList.add('price-visibility-hidden'),
      document.querySelector(`#price-${this.dataset.section} .product__select_variant`).classList.remove('hide')
    ) : "";
    document.querySelectorAll('.shopify-payment-button').length > 0 ? document.querySelectorAll('.shopify-payment-button').forEach((button) => { button.classList.add('visibility-hidden')}) : "";
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[id^=VariantJson-').textContent);
    return this.variantData;
  }

  /* --- Image changing => Change variant */
  createVariantImage(product) {
    const variantImageObject = {};
    product.variants.forEach((variant) => {
      if ( typeof variant.featured_image !== 'undefined' && variant.featured_image !== null ) {
        const variantImage = variant.featured_image.src.split('?')[0].replace(/http(s)?:/, '');
        variantImageObject[variantImage] = variantImageObject[variantImage] || {};
        product.options.forEach((option, index) => {
          const optionValue = variant.options[index];
          const optionKey = `option-${index}`;
          if ( typeof variantImageObject[variantImage][optionKey] === 'undefined' ) {
            variantImageObject[variantImage][optionKey] = optionValue;
          } else {
            const oldValue = variantImageObject[variantImage][optionKey];
            if (oldValue !== null && oldValue !== optionValue) {
              variantImageObject[variantImage][optionKey] = null;
            }
          }
        });
      }
    });
    return variantImageObject;
  }

  selectVariant() {
    var self = this;
    const product = document.querySelector('[id^=ProductJson-');

    if (product) {
      const sectionId = product.id.replace("ProductJson-", "shopify-section-");
      const thumbnails = document.querySelectorAll('#'+ sectionId + ' .product__media.image-container img[src*="/products/"]');
      if (thumbnails.length > 1) {
        const productObject = JSON.parse(product.innerHTML);
        const variantImages = this.createVariantImage(productObject);
        // need to check variants > 1
        if (productObject.variants.length > 1) {
          document.addEventListener('DOMContentLoaded', function(){
            if(document.documentElement.clientWidth >= 780){
              if(document.querySelector('#' + sectionId + ' .product__media--main:not(.triple-slider-prev):not(.triple-slider-next)').getAttribute('data-active') == "true"){
                self.listenChangeSlider(sectionId, productObject, variantImages);
              }
            } else {
              self.listenChangeSlider(sectionId, productObject, variantImages);
            }
          }) 
        }
      }
    }
  }

  listenChangeSlider(sectionId, productObject, variantImages){
    var self = this;
    var slider = document.querySelector('#' + sectionId + ' .product__media-wrapper.swiper-initialized:not(.triple-slider-prev):not(.triple-slider-next):not(.product__media--thumbnails)');
    if(slider){
      slider.swiper.on('activeIndexChange', function (e) {
        const {slides: r, activeIndex: n} = e;
        const ev = {};
        ev.target = r[n].querySelector('img[src*="/products/"]');
        if(typeof ev.target !== "undefined") self.updateVariant(ev, sectionId, productObject, variantImages)
      });
    }
  }

  updateVariant(event, id, product, variantImages) {
    var self = this;
    const arrImage = event.target.src.split('?')[0].replace(/http(s)?:/, '').split('.');
    const strExtention = arrImage.pop();
    const strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/, '');
    const strNewImage = `${arrImage.join('.')}.${strRemaining}.${strExtention}`;
    let selector, change = false;
    if (typeof variantImages[strNewImage] !== 'undefined') {
      self.options = [];
      product.variants.forEach((option, index) => {
        const optionValue = variantImages[strNewImage][`option-${index}`];
        if(optionValue !== null && optionValue !== undefined) {
          const selects = document.querySelectorAll('#'+ id + ' [data-options-index]');
          const options = selects[index].options ? selects[index].options : selects;
          for (let option, n = 0; (option = options[n]); n += 1) {
            if (option.value === optionValue) {
              self.options.push(optionValue),
              change = true,
              selects[index].options ? selects[index].value = optionValue : (selects[n].checked = true, selects[n].dispatchEvent(new Event('change')));
              selector = selects[index].closest('.variant-select');
              return;
            }
          }
        }
      });
      if(change) {
        selector.dispatchEvent(new CustomEvent('sliderChange'));
      }
    }
  }
}
customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}
customElements.define('variant-radios', VariantRadios);

class Magnify extends HTMLElement {
  constructor(){
    super();

    var self = this;

    if(document.documentElement.clientWidth >= 780){
      self.magnify();
    }

    window.on('resize', theme.utils.debounce(300, function() {
      if(document.documentElement.clientWidth >= 780)
        self.magnify();
      else
        self.removeMagnify();
    }));
  }

  magnify(){
    var self = this, Img = this.querySelector('img');

    if(Img !== null){
      if(!this.querySelector('.magnify__large-img')){
        var largeImg = document.createElement('div');
        largeImg.classList.add('magnify__large-img');
        largeImg.style.backgroundImage = 'url(' + Img.getAttribute('src').replace('width=550', 'width=2000') + ')';
      } else {
        var largeImg = this.querySelector('.magnify__large-img');
      }

      self.querySelector('.image-container').appendChild(largeImg);

      this.addEventListener("mousemove", function (e) {
        self.zoom(e, Img, largeImg)
      }, false);
    }
  }

  removeMagnify(){
    this.removeEventListener("mousemove", function (e) {
      self.zoom(e, Img, largeImg)
    }, false);
  }

  zoom(e, Img, largeImg){
      let original = Img,
      magnified = largeImg,
      style = magnified.style,
      rect = this.getBoundingClientRect(),
      scrollX = e.offsetX,
      scrollY = e.offsetY,
      imgWidth = original.width,
      imgHeight = original.height,

      xperc = (scrollX / imgWidth) * 100,
      yperc = (scrollY / imgHeight) * 100;

    if (scrollX > 0.01 * imgWidth) xperc += 0.15 * xperc;

    if (scrollY >= 0.01 * imgHeight)   yperc += 0.15 * yperc;

    style.backgroundPositionX = xperc + "%";
    style.backgroundPositionY = yperc + "%";

    style.left = scrollX - 50 + "px";
    style.top = scrollY - 50 + "px";
  }
}
customElements.define('image-magnify', Magnify);

class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  hide() {
    super.hide();
    if(super.querySelector('.product__media-wrapper.swiper-initialized')) super.querySelector('.product__media-wrapper').swiper.destroy();
    super.querySelector('.product-media-modal__content').innerHTML = '';
    theme.utils.pauseAllMedia();
  }

  show(opener) {
    super.show(opener);
    this.loadContent();
    this.showActiveMedia();
  }

  loadContent() {
    var content = super.closest('.product__left').querySelector('.product__media-wrapper');
    if(content.classList.contains('triple-slider-prev')){
      content = content.closest('.triple-slider');
    }

    super.querySelector('.product-media-modal__content').innerHTML = '';
    super.querySelector('.product-media-modal__content').appendChild(content.cloneNode(true));
    super.querySelectorAll('.product__media.image-container img[src*="/products/"]').forEach((image) => {
      var src = image.getAttribute('src').replace('width=550', 'width=2800 2800w');
      image.setAttribute('srcset', image.getAttribute('srcset') + src);
      image.setAttribute('sizes', image.getAttribute('srcset').replace('50vw', '100vw'));
    });
  }

  showActiveMedia() {
    let mediaId = this.openedBy.closest('modal-opener').querySelector('[data-media-id]').getAttribute('data-media-id');
    this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
      element.classList.remove('active');
    });

    const productImages = super.querySelector('.product__media-wrapper:not(.triple-slider-prev):not(.triple-slider-next)');
    if(document.documentElement.clientWidth >= 780){
      if(productImages.getAttribute('data-active') == "true"){
        if(productImages.classList.contains('triple-slider-main')){
          var content = productImages.closest('.triple-slider');
          productImages.classList.remove('triple-slider-main');
          content.querySelector('.triple-slider-prev').remove();
          content.querySelector('.triple-slider-next').remove();
          new theme.Swiper_Slider(productImages);
        } else {
          new theme.Swiper_Slider(productImages);
        }
        let index = parseInt(productImages.querySelector(`[data-media-id="${this.dataset.section}-${mediaId}"]`).getAttribute('data-index'));
        productImages.swiper.slideTo(index);
      } else {
        const activeMedia = super.querySelector(`[data-media-id="${mediaId}"]`);
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
      }
    } else {
      if(productImages.classList.contains('triple-slider-main')){
        var content = productImages.closest('.triple-slider');
        productImages.classList.remove('triple-slider-main');
        content.querySelector('.triple-slider-prev').remove();
        content.querySelector('.triple-slider-next').remove();
        new theme.Swiper_Slider(productImages);
      } else {
        new theme.Swiper_Slider(productImages);
      }
      let index = parseInt(productImages.querySelector(`[data-media-id="${this.dataset.section}-${mediaId}"]`).getAttribute('data-index'));
      productImages.swiper.slideTo(index);
    }
  }
}
customElements.define('product-modal', ProductModal);

class ProductModel extends DeferredMedia {
  constructor() {
    super();
  }

  loadContent() {
    super.loadContent();

    Shopify.loadFeatures([
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: this.setupModelViewerUI.bind(this),
      },
    ]);
  }

  setupModelViewerUI(errors) {
    if (errors) return;

    if(this.querySelector('.shopify-model-viewer-ui')) {
      this.querySelector('.shopify-model-viewer-ui').remove();
      var content = this.querySelector('template').content.firstElementChild.cloneNode(true);
      this.appendChild(content);
      var model = this.querySelector('model-viewer');
      this.modelViewerUI = new Shopify.ModelViewerUI(model);
    } else {
      var model = this.querySelector('model-viewer');
      this.modelViewerUI = new Shopify.ModelViewerUI(model);
    }

    if(this.closest('.swiper.swiper-initialized')) {
      var slider = this.closest('.swiper.swiper-initialized');
      if(this.closest('.swiper-slide-active')) slider.swiper.allowTouchMove = false;

      model.addEventListener('shopify_model_viewer_ui_toggle_play', function () {
        if(this.closest('.swiper-slide-active')) slider.swiper.allowTouchMove = false;
      })

      model.addEventListener('shopify_model_viewer_ui_toggle_pause', function () {
        if(this.closest('.swiper-slide-active')) slider.swiper.allowTouchMove = true;
      });
    }
  }
}
customElements.define('product-model', ProductModel);

document.querySelectorAll('.product__media-item a').forEach((image) => {
  image.addEventListener('click', function(e){
    e.preventDefault();
    return false;
  });
})

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () =>
        this.setupShopifyXR()
      );
      return;
    }

    document.querySelectorAll('[id^="ModelJson-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};
window.addEventListener('DOMContentLoaded', () => { if(window.ProductModel) window.ProductModel.loadShopifyXR(); });

class ProductThumbnails extends HTMLElement {
  constructor(){
    super();
    var self = this;

    window.addEventListener('DOMContentLoaded', () => {
      self.init();
    });

    document.addEventListener('shopify:section:load', (evt) => {
      if(self.closest(`#${evt.target.id}`)) {
        self.init();
      }
    });
  }

  init(){
    var self = this;

    if(this.swiper) {
      var sliders = this.closest('.product__left').querySelectorAll('.product__media--main:not(.triple-slider-prev):not(.triple-slider-next)');

      sliders.forEach((slider) => {
        slider.swiper.thumbs.swiper = this.swiper;
        slider.swiper.thumbs.init();

        slider.swiper.on('activeIndexChange', function(e){
          const { activeIndex: n } = e;
          self.swiper.slideTo(n);
        });
      })

      if(document.documentElement.clientWidth > 780){
        if(this.swiper.slides.length < 5 && this.swiper.dataset.direction != "vertical")
          this.querySelector('.swiper-wrapper').classList.add('flex-justify--center')
      }
    }
  }
}
customElements.define('product-thumbnails', ProductThumbnails);

class StickyATC extends HTMLElement {
  constructor() {
    super();

    var self = this;
    var productAvailable = false;
    var productATC = this.closest('.product-section').querySelector('product-form .product-form__submit');
    if(productATC && !productATC.getAttribute('disabled')){
      productAvailable = true;
    }

    if(productAvailable){
      this.visible();

      window.addEventListener('scroll',
        theme.utils.throttle(function(){
          self.visible()
        }, 200)
      );

      window.addEventListener('resize',
        theme.utils.throttle(function(){
          self.visible()
        }, 200)
      );

      document.addEventListener('shopify:section:load', function(e){
        self.visible()
      });
    }
  }

  visible() {
    var button_ATC = this.closest('.product-section').querySelector('product-form .product-form__submit');
    var footer = document.querySelector('footer');
    var scroll = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    if(button_ATC && ((!this.classList.contains('mu--hide') && document.documentElement.clientWidth > 780) || (!this.classList.contains('s--hide') && document.documentElement.clientWidth <= 779))){
      if(theme.utils.isInViewport(button_ATC) || scroll < (theme.utils.offset(button_ATC).top + button_ATC.getBoundingClientRect().height) || scroll == 0 ){
        if(this.classList.contains('active')) this.classList.remove('active'), footer.style.marginBottom = '';
      } else {
        if(!this.classList.contains('active')) this.classList.add('active'), footer.style.marginBottom = this.getBoundingClientRect().height + 'px';
      }
    }
  }
}
customElements.define('sticky-atc', StickyATC);

class CountDown extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      days: this.querySelector(".product__countdown-timer-item-days"),
      hours: this.querySelector(".product__countdown-timer-item-hours"),
      minutes: this.querySelector(".product__countdown-timer-item-minutes"),
      seconds: this.querySelector(".product__countdown-timer-item-seconds")
    };

    this.countdown;

    const date = /\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}/g.test(this.dataset.time) ? this.dataset.time : false;
    if(date != false){
      this.convertFormat(date);
    }
  }

  convertFormat(str) {
    const [dateComponents, timeComponents] = str.split(' ');

    const [day, month, year] = dateComponents.split('/');
    const [hours, minutes, seconds] = timeComponents.split(':');

    const date = new Date(+year, month - 1, +day, +hours, +minutes, +seconds);

    this.timer(date.getTime());
  }

  timer(seconds) {
    let self = this;

    this.countdown = setInterval(() => {
      let now = Date.now();
      const secondsLeft = Math.round((seconds - now) / 1000);

      if(secondsLeft <= 0) {
        clearInterval(self.countdown);
        return;
      };

      self.displayTimeLeft(secondsLeft);

    },1000);
  }

  displayTimeLeft(seconds) {
    this.selectors.days.querySelector('.product__countdown-timer-item-value-base').textContent = Math.floor(seconds / 86400) % 60 < 10 ? `0${Math.floor(seconds / 86400)}` : Math.floor(seconds / 86400);
    this.selectors.hours.querySelector('.product__countdown-timer-item-value-base').textContent = Math.floor((seconds % 86400) / 3600) % 60 < 10 ? `0${Math.floor((seconds % 86400) / 3600)}` : Math.floor((seconds % 86400) / 3600) % 60;
    this.selectors.minutes.querySelector('.product__countdown-timer-item-value-base').textContent = Math.floor((seconds % 86400) % 3600 / 60) % 60 < 10 ? `0${Math.floor((seconds % 86400) % 3600 / 60)}` : Math.floor((seconds % 86400) % 3600 / 60) % 60 ;
    this.selectors.seconds.querySelector('.product__countdown-timer-item-value-base').textContent = seconds % 60 < 10 ? `0${seconds % 60}` : seconds % 60;
  }
}
customElements.define('count-down', CountDown);